// @flow strict
import TeamItem from './teamItem';
export default TeamItem;
